<div class="grid">
    <div class="col-12">
        <form>
            <p-card [header]="'ADD_NEW_VEHICLE_MAKE' | translate">
                <p-messages [closable]="true" />
                <div
                    class="p-fluid p-formgrid grid"
                    [formGroup]="vehicleMakeForm"
                >
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500">{{
                            "VEHICLE_MAKE_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="name"
                            [placeholder]="'ENTER_VEHICLE_MAKE' | translate"
                            pInputText
                            formControlName="name"
                        />
                    </div>
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            (click)="backToVehicleMakes()"
                            [label]="'BACK' | translate"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-check"
                            [label]="'SAVE' | translate"
                            severity="primary"
                            pButton
                            [disabled]="!vehicleMakeForm.valid"
                            pRipple
                            (click)="saveMake()"
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
